module.exports = __webpack_public_path__ + "static/images/hero.93aa31066cec5cead279ca8c81ec7d90.jpg";